import React from "react";
import { motion } from "framer-motion";
import { MessageCircle, PhoneCall, ArrowUpRight } from "lucide-react";
import { useLang } from "../../lib/i18n";
import { useSettings } from "../../lib/queries";

export default function CTA() {
  const { t, pick } = useLang();
  const { data: settings } = useSettings();
  const wa = (settings?.whatsapp || "+905337819108").replace(/[^0-9]/g, "");

  return (
    <section data-testid="cta-section" className="py-32 relative overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="relative rounded-3xl border border-[#A855F7]/25 bg-gradient-to-br from-[#5B21B6]/25 via-[#101018] to-[#08080D] p-12 md:p-20 overflow-hidden">
          <div className="absolute inset-0 pointer-events-none opacity-40 grid-backdrop" />
          <div className="absolute -top-1/2 -right-1/4 w-[600px] h-[600px] rounded-full bg-[#A855F7]/20 blur-3xl" />

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative max-w-4xl"
          >
            <div className="font-mono-ui text-[10px] tracking-[0.3em] text-[#A855F7] uppercase mb-6">
              — CTA
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl uppercase tracking-tighter text-white leading-[0.95]">
              {pick(settings || {}, "cta_title") || "Markanız İçin Güçlü Bir Hikâye Yazmaya Hazır mısınız?"}
            </h2>
            <p className="mt-8 text-white/70 text-lg md:text-xl max-w-2xl">
              {pick(settings || {}, "cta_body") || ""}
            </p>
            <div className="mt-10 flex flex-wrap gap-4">
              <a
                data-testid="cta-whatsapp"
                href={`https://wa.me/${wa}`}
                target="_blank"
                rel="noreferrer"
                className="btn-primary"
              >
                <MessageCircle size={16} />
                {t("cta_whatsapp")}
              </a>
              <button
                data-testid="cta-form"
                onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
                className="btn-ghost"
              >
                {t("cta_form")}
                <ArrowUpRight size={14} />
              </button>
              <a
                data-testid="cta-call"
                href={`tel:${(settings?.phone || "").replace(/\s/g, "")}`}
                className="btn-ghost"
              >
                <PhoneCall size={14} />
                {t("cta_call")}
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
